<template>
  <v-dialog
    v-model="dialog"
    :max-width="width"
    :style="{ zIndex: zIndex }"
    @keydown.esc="cancel"
    persistent
  >
    <v-card>
      <v-card-title class="py-0 pl-0 pr-2">
        <v-chip class="ma-2" color="orange darken-3" outlined pill>
          <v-icon left> mdi-alert-octagram </v-icon>
          {{ title }}
        </v-chip>
        <v-spacer></v-spacer>
        <v-btn icon color="red" @click="cancel">
          <v-icon>mdi-close-octagon-outline</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-text="messages[0]" class="py-1"></v-card-text>
      <v-card-text
        v-if="messages[1]"
        class="py-1 mb-1 text-display-6 font-weight-bold indigo--text"
      >
        [ {{ messages[1] }} ]
      </v-card-text>
      <template v-if="kets">
        <v-card-text
          class="py-1 orange--text text--darken-3"
          v-for="(ket, index) in kets"
          :key="index"
        >
          {{ ket }}
        </v-card-text>
      </template>
      <v-card-actions class="mt-2">
        <v-btn @click="cancel" :color="isDelete ? 'success' : 'red'" dark
          >Batal</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn @click="agree" :color="isDelete ? 'grey' : 'success'" dark
          >Ya, Saya yakin!</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      isDelete: false,
      dialog: false,
      resolve: null,
      reject: null,
      messages: [],
      kets: [],
      title: null,
      width: 400,
      zIndex: 200,
    };
  },

  methods: {
    open(title, messages, kets, width, isDelete) {
      this.dialog = true;
      this.title = title;
      this.messages = messages;
      if (kets) {
        this.kets = kets;
      }
      if (width) {
        this.width = width;
      }
      if (isDelete) {
        this.isDelete = isDelete;
      }
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.reset();
      this.resolve(true);
    },
    cancel() {
      this.reset();
      this.resolve(false);
    },
    reset() {
      this.dialog = false;
      setTimeout(() => {
        this.title = null;
        this.messages = [];
        this.kets = [];
        this.isDelete = false;
      }, 250);
    },
  },
};
</script>

<style>
</style>